<template>
  <ElForm
    label-position="top"
    hide-required-asterisk
    class="new-app-basic-info-form"
    :model="info"
    :rules="rules"
  >
    <ElFormItem
      prop="nameFa"
      :error="errors.nameFa"
      :label="$t('APPS.DRAFT.STEPS.APP_INFO.APP_NAME_FA')"
    >
      <ElInput
        ref="firstInput"
        v-model="info.nameFa"
        tabindex="1"
        maxlength="36"
        show-word-limit
      />

      <small class="text-disabled">
        {{ $t('APPS.DRAFT.STEPS.APP_INFO.APP_NAME_HINT') }}
      </small>
    </ElFormItem>

    <OptionalFormItem
      prop="nameEn"
      :initial-visibility="Boolean(info.nameEn)"
      :error="errors.nameEn"
      :label="$t('APPS.DRAFT.STEPS.APP_INFO.APP_NAME_EN')"
      @remove="info.nameEn = ''"
    >
      <ElInput
        v-model="info.nameEn"
        class="text-latin"
        dir="ltr"
        tabindex="2"
        maxlength="36"
        show-word-limit
      />
    </OptionalFormItem>

    <ElFormItem
      prop="shortDescriptionFa"
      :error="errors.shortDescriptionFa"
      :label="$t('APPS.DRAFT.STEPS.APP_INFO.SHORT_DESCRIPTION_FA')"
    >
      <ElInput v-model="info.shortDescriptionFa" tabindex="3" />
    </ElFormItem>

    <OptionalFormItem
      prop="shortDescriptionEn"
      :initial-visibility="Boolean(info.shortDescriptionEn)"
      :error="errors.shortDescriptionEn"
      :label="$t('APPS.DRAFT.STEPS.APP_INFO.SHORT_DESCRIPTION_EN')"
      @remove="info.shortDescriptionEn = ''"
    >
      <ElInput
        v-model="info.shortDescriptionEn"
        class="text-latin"
        dir="ltr"
        tabindex="4"
      />
    </OptionalFormItem>

    <ElFormItem
      ref="descriptionFaItem"
      prop="descriptionFa"
      :error="errors.descriptionFa"
      :label="$t('APPS.DRAFT.STEPS.APP_INFO.DESCRIPTION_FA')"
    >
      <Editor
        v-model="info.descriptionFa"
        editor-tab-index="6"
        dir="rtl"
        @blur="emitFormItemBlur"
      />
    </ElFormItem>

    <OptionalFormItem
      prop="descriptionEn"
      :initial-visibility="Boolean(info.descriptionEn)"
      :error="errors.descriptionEn"
      :label="$t('APPS.DRAFT.STEPS.APP_INFO.DESCRIPTION_EN')"
      @remove="info.descriptionEn = ''"
    >
      <Editor
        v-model="info.descriptionEn"
        class="text-latin"
        dir="ltr"
        editor-tab-index="7"
      />
    </OptionalFormItem>
  </ElForm>
</template>

<script>
import Editor from '@@/common/Editor';
import OptionalFormItem from '@@/common/OptionalFormItem';

export default {
  name: 'AppInfoForm',
  components: { Editor, OptionalFormItem },

  props: {
    value: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      info: {
        nameFa: '',
        nameEn: '',
        shortDescriptionFa: '',
        shortDescriptionEn: '',
        descriptionFa: '',
        descriptionEn: '',
      },
    };
  },

  computed: {
    rules() {
      const requiredRule = {
        required: true,
        message: this.$t('VALIDATION_REQUIRED_ERR'),
        type: 'string',
        whitespace: true,
        trigger: ['blur'],
      };

      return {
        nameFa: requiredRule,
        shortDescriptionFa: requiredRule,
        descriptionFa: requiredRule,
      };
    },
  },

  watch: {
    info: {
      deep: true,
      handler(value) {
        this.$emit('input', { ...value });
      },
    },
  },

  mounted() {
    this.info = {
      ...this.info,
      ...this.value,
    };

    this.$refs.firstInput?.focus();
  },

  methods: {
    emitFormItemBlur(e) {
      // it is for triggering form validation
      this.$refs.descriptionFaItem?.$emit('el.form.blur', e);
    },
  },
};
</script>

<style lang="scss">
.new-app-basic-info-form {
  max-width: 500px;
}
</style>
